import React, { useEffect, useState } from "react";
import "../style/infoPopup.css";

function InfoPopup({
  generalData,
  date,
  switchInfo,
  singleInfo,
  hour,
  celsius,
}) {
  const [isVisible, setIsVisible] = useState(false);

  // useEffect is used to when component is assembly and use isVisble variable to set true
  // when is true the component apply the class property visible
  useEffect(() => {
    setIsVisible(true);
  }, []);

  const closeInfoPopup = (e) => {
    e.stopPropagation(); // Ferma l'effetto del genitore
    setIsVisible(false);
    setTimeout(() => {
      switchInfo(); // Chiude il popup dopo la transizione
    }, 300);
  };

  return (
    <div
      className={`infoContainer ${
        isVisible ? "infoContainerVisible" : "infoContainerNotVisible"
      }`}
      onClick={closeInfoPopup}
    >
      <div
        className={`topBottom ${
          isVisible ? "topBottomVisible" : "topBottomNotVisible"
        }`}
      >
        <div className="topInfo">
          <div className="dateInfo">
            <p className="cityNameSecondary">{date}</p>
            <p className="cityNameSecondary">Forecast {hour}</p>
          </div>
          <p className="cityName">{generalData.city.name}</p>
        </div>
        <div className="bottomInfo">
          <div>
            <h3 className="titleInfo">Sky Conditions</h3>
            <div className="completeInfo" translate="no">
              <p>{singleInfo.weather[0].description},&nbsp;</p>
              <p>probability rain {(singleInfo.pop * 100).toFixed(0)}%&nbsp;</p>
              <p>Cover&nbsp;{singleInfo.clouds.all}%</p>
            </div>
          </div>
          <div>
            <h3 className="titleInfo">Temperature °c</h3>
            <div className="completeInfo">
              <table>
                <tr className="">
                  <th>Temperature</th>
                  <th>Max</th>
                  <th>Min</th>
                  <th>Perceived</th>
                </tr>
                <tr key="" className="rowInfo">
                  <td key="">{celsius(singleInfo.main.temp)}</td>
                  <td key="">{celsius(singleInfo.main.temp_max)}</td>
                  <td key="">{celsius(singleInfo.main.temp_min)}</td>
                  <td key="">{celsius(singleInfo.main.feels_like)}</td>
                </tr>
              </table>
            </div>
          </div>
          <div>
            <h3 className="titleInfo">Humidity & Visibility</h3>
            <div className="completeInfo">
              <p>Humidity{singleInfo.main.humidity}%&nbsp;</p>
              <p>Visibility {singleInfo.visibility}m</p>
            </div>
          </div>
          <div>
            <h3 className="titleInfo">Wind</h3>
            <div className="completeInfo">
              <table>
                <tr>
                  <th key="">Speed</th>
                  <th key="">Direction</th>
                  <th key="">Gust</th>
                </tr>
                <tr key="" className="rowInfo">
                  <td>{singleInfo.wind.speed}km/h</td>
                  <td>{singleInfo.wind.deg}°</td>
                  <td>{singleInfo.wind.gust}km/h</td>
                </tr>
              </table>
            </div>
          </div>
          <div>
            <h3 className="titleInfo">Pressure hPa</h3>
            <div className="completeInfo">
              <table>
                <tr key="">
                  <th>Ground</th>
                  <th>Mean pressure</th>
                  <th>Sea level</th>
                </tr>
                <tr className="rowInfo">
                  <td>{singleInfo.main.grnd_level}</td>
                  <td>{singleInfo.main.pressure}</td>
                  <td>{singleInfo.main.sea_level}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoPopup;
